<template id="boton-proceso-tab-ap">
  <div>
    <div class="btn-proceso">
      <v-layout
        class="botones-colores"
        align-center
        justify-center
        fill-height
        wrap
      >
        <v-flex
          xs1
          v-for="(btn, index) in lstBtn"
          :key="index"
          @click="activateBtn(btn)"
        >
          <v-flex botones>
            <mini-statistic
              :icon="btn.icon"
              :title="btn.title"
              :sub-title="btn.subtitle"
              :color="btn.color"
              :class="btn.class"
              :value="true"
            ></mini-statistic>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="tab-aplicacion">
      <recepcion-sub-tab
        v-if="tab == 'Recepcion'"
        :show="true"
        :tipeView="'modifica'"
      ></recepcion-sub-tab>
      <seleccion-sub-tab
        v-if="subPro == 'SELECCION'"
        :show="true"
        :tipeView="'modifica'"
      ></seleccion-sub-tab>
      <centro-sub-tab
        v-if="subPro == 'CENTROS-AP'"
        :show="true"
        :tipeView="'modifica'"
      ></centro-sub-tab>
      <revision-sub-tab
        v-if="subPro == 'REVISION'"
        :show="true"
        :tipeView="'modifica'"
      ></revision-sub-tab>
      <traspaso-co-sub-tab
        v-if="subPro == 'TRASPASO'"
        :show="true"
        :tipeView="'modifica'"
      ></traspaso-co-sub-tab>
      <visita-sub-tab
        v-if="subPro == 'VISITA'"
        :show="true"
        :tipeView="'modifica'"
      ></visita-sub-tab>
      <acomodacion-sub-tab
        v-if="subPro == 'ACOMODACION'"
        :show="true"
        :tipeView="'modifica'"
      ></acomodacion-sub-tab>
      <aplicacion-sub-tab
        v-if="subPro == 'APLICACION'"
        :show="true"
        :tipeView="'modifica'"
      ></aplicacion-sub-tab>
      <traspaso-ca-sub-tab
        v-if="subPro == 'TRASPASOS'"
        :show="true"
        :tipeView="'modifica'"
      ></traspaso-ca-sub-tab>
      <captura-sub-tab
        v-if="subPro == 'RETORNO'"
        :show="true"
        :tipeView="'modifica'"
      ></captura-sub-tab>
      <administracion-sub-tab
        v-if="subPro == 'ADMINISTRACION'"
        :show="true"
        :tipeView="'modifica'"
      ></administracion-sub-tab>
      <reportes-sub-tab
        v-if="subPro == 'REPORTES'"
        :show="true"
        :tipeView="'modifica'"
      ></reportes-sub-tab>
    </div>
  </div>
</template>

<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import RecepcionSubTab from "@/modules/aplicacion/views/recepcion/RecepcionSubTab.vue";
import SeleccionSubTab from "@/modules/aplicacion/views/seleccion/proceso/SeleccionSubTab.vue";
import CentroSubTab from "@/modules/aplicacion/views/centros/CentroSubTab.vue";
import RevisionSubTab from "@/modules/aplicacion/views/revision/RevisionSubTab.vue";
import TraspasoCoSubTab from "@/modules/aplicacion/views/traspasoCo/TraspasoSubTab.vue";
import VisitaSubTab from "@/modules/aplicacion/views/visita/VisitaSubTab.vue";
import AcomodacionSubTab from "@/modules/aplicacion/views/acomodacion/AcomodacionSubTab.vue";
import AplicacionSubTab from "@/modules/aplicacion/views/aplicacion/AplicacionSubTab.vue";
import TraspasoCaSubTab from "@/modules/aplicacion/views/traspasoCa/TraspasoSubTab.vue";
import CapturaSubTab from "@/modules/aplicacion/views/captura/CapturaSubTab.vue";
import AdministracionSubTab from "@/modules/adminDocs/views/AdministracionSubTab.vue";
import ReportesSubTab from "@/modules/prodReport/views/ReportesSubTab.vue";

export default {
  name: "boton-proceso-tab-ap",
  props: {
    lstBtn: "",
  },
  data() {
    return {
      aplicacionBtn: false,
      tab: "Recepcion",
      subPro: "Sin Proceso",
    };
  },
  components: {
    MiniStatistic,
    RecepcionSubTab,
    SeleccionSubTab,
    CentroSubTab,
    RevisionSubTab,
    TraspasoCoSubTab,
    VisitaSubTab,
    AcomodacionSubTab,
    AplicacionSubTab,
    TraspasoCaSubTab,
    CapturaSubTab,
    AdministracionSubTab,
    ReportesSubTab,
  },
  created() {
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proSelectedStored = this.$store.getters.proSelectedStored;
  },

  mounted() {},

  watch: {
    lstBtn(val) {
      // console.log("watch:" +this.subPro + ":" + this.tab + "::");
      if (this.subPro != "") {
        let btnSeleccionado = this.lstBtn.filter((d) =>
          this.subPro
            .split(" ")
            .every((v) => d.title.toLowerCase().includes(v.toLowerCase()))
        );
        if (btnSeleccionado.length > 0) {
          btnSeleccionado[0].class =
            "activo rombo " + this.subPro.toLowerCase();
          //console.log("id:" + btnSeleccionado.length + ":" + btnSeleccionado[0].class + "::");
        } else {
          let subProceso = this.subPro.toLowerCase();
          this.lstBtn.forEach((b) => {
            if (subProceso == b.subPro.toLowerCase()) {
              b.class = "activo rombo " + b.subPro.toLowerCase();
              //console.log("else:" + b.title + ":" + b.class + "::");
            }
          });
        }
      }
    },
  },
  methods: {
    activateBtn(btn) {
      this.tab = btn.tab;
      this.subPro = btn.subPro;
      this.$store.commit("sub_tab_state", this.tab);
      this.$store.commit("sub_pro_tab_state", this.subPro);

      this.lstBtn.forEach((b) => {
        if (b.title != btn.title) {
          //desactiva b: quita "activo" y agrega  elevation-10
          b.class = b.class.replaceAll("activo", "");
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " elevation-10";
          //console.log("desactiva:" + b.title + ":" + b.class + "::");
        } else {
          //activa b:agrega activo, quita  elevation-10
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " activo";
          //console.log("activa:" + b.title + ":" + b.class + "::");
        }
      });
    },
  },
};
</script>
